<template>
  <div class="aliados">
    <h1 class="aliados-title"></h1>
    <div class="aliados-container">
      <div v-for="post in posts" :key="post.id">
        <a :href="post.acf.aliado_url" class="btn-aliados">
          <img v-if="post._embedded['wp:featuredmedia']" class="img-aliados" :src="post._embedded['wp:featuredmedia'][0].source_url" width="150" heigth="150" />
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'

export default {
  name: 'Aliados',
  data () {
  return {
    postsUrl: "https://foto-urbana.credopop.com/wp-json/wp/v2/aliados?order=asc",
    queryOptions: {
      per_page: 15, // Only retrieve the 10 most recent blog posts.
      page: 1, // Current page of the collection.
      _embed: true //Response should include embedded resources.
    },
    // Returned Posts in an Array
    posts: []
  };
},
methods: {
  // Get Recent Posts From WordPress Site
  getRecentMessages() {
    axios
      .get(this.postsUrl, { params: this.queryOptions })
      .then(response => {
        this.posts = response.data;
      })
      .catch(error => {
        console.log(error);
      });
  },
},
mounted() {
  this.getRecentMessages();
}
}
</script>
<style>
.aliados{
    width: 100%;
    height: auto ;
    margin-top: 50px;
    margin-bottom: 50px;
    padding: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
}
.aliados-title{
    margin-bottom: 40px;
    font-family: Raleway;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 21px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    margin-bottom: 20px;
}
.aliados-container{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
}
.img-aliados{
    height: 150px;
    padding: 10px;
}
</style>
